package org.multiplatform.kotfolio.pages.kids

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("plants")
@Composable
fun KidsPlantsPage() {
    BlogLayout(
        PageProperties(
            "Plants",
            "There are different types of plants around us like trees, shrubs, herbs, climbers and creepers." ),
        BlogProperties("Kids", "Plants")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Plants",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "There are different types of plants around us like trees, shrubs, herbs, climbers and creepers. Simply put a plant, it is venerable, that grows in dirt, a living organism that selectively acquires different elements needed to sustain its life with the help of sunlight, air, and water. The structure of a plant has many unique components that enable to grow and do its work.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "TREES- Very tall and big plants are called trees. Eg- peepal, coconut, gulmohar etc.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "SHRUBS- Plants with smaller stems that branch off near the ground are called shrubs or bushes. Eg- rose, hibiscus, henna etc.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "HERBS- Plants with small, weak, thin and green stems are called herbs. Eg- grass, mint, coriander etc.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "CLIMBERS- Plants with very weak stems that need support to grow. Eg- money plant, pea etc.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "CREEPERS- Plants having very weak stem and spread on the ground. Eg- pumpkin, water melon etc.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "New Words",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Shrubs",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Herbs",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Climbers",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Root System",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Lamina",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Word Galaxy",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Festoon ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "germinate - to grow from seed.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "anchor-to give support.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Questions",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Name the plants whose eaves have a distinct smell?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Mint and Fucalyptus (નીલગિરિ) plant leave have a distinct smell.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Which Leaves are used as a festoon during Indian festival?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Mango trees leaves cre used as a festoon during Indian festival.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is a trunk?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The thick, strong and woody stems called trunk.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Give any two uses of plants?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "1. Plants produce food for all other living organisms.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )

                        SpanText(
                            text = "2. Plants give us oxygen, which all Living things need to survive.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is Photosynthesis?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The leaves use water and carbon dioxide is the presence of sunlight to prepare food.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Which characteristics of the flower attract insects?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Colour, sweet smell, shape, nectar pattern, and size are the characteristics of the flowers attract insect.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "List the conditions required for a seed to grow into anew plant?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Seed contain baby plants in them. The seed into a new pant if it get enough water, air and warmth.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Leaves are green in colour.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The leaves are green in color due to the presence of the chlorophyll (ક્લોરોફિલ).",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )

                        SpanText(
                            text = "Leaves are mostly green in colour due to the presence of green pigment called chlorophyll.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Meem is known us medical plant?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Neem is known as a medical plant because of its health benefit and uses. It also well as promote healthy hair growth and also used for to cure from skin infection.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why can't plants make their food at night?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Plants need sunlight to perform photosynthesis. Since there is no sunlight at night they can not make food.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }
            }

            SpanText(
                text = "Questions",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which pigment, found in the chloroplasts of plants, is responsible for absorbing light energy during photosynthesis?: chlorophyll",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these planets is farthest from the Earth? Uranus",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "What is the sun mainly made of? Gases",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "What is the name of the natural fibre extracted from the outer husk of the coconut? Coir",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "According to Indian custom, breaking which of these is considered auspicious at the beginning of something new? Coconut",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these shares its name with a type of computer key? Space",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "'Pistil' and 'stamen' are reproductive parts found in which part of the plant? The pistil (female) and stamen (male) are the reproductive parts of a plant, and they are located in the flower, which is the primary reproductive structure for flowering plants (angiosperms).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In which US national park is Hyperion, the world's tallest living tree, located? Redwood National Park",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which flower's petals are most commonly used to prepare gulkand? Rose",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Leaves with parallel veins are generally found in: Monocot plants",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of the following is considered a biotic component of an ecosystem? Plants",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }
        }
    }
}

//According to Indian scriptures, Rohini, Anuradha, Vishakha and Swati, all are names of which of these? Nakshatras (lunar constellations)
//Which of these statements is not true about the planet Mars? It has rings
//Which inventor who helped develop the incandescent light bulb was called the 'Wizard of Menlo Park'? Thomas Alva Edison
//During which of these processes is urea mainly used? agriculture as a nitrogen-rich fertilizer
//Which of the following food items usually contains the least amount of protein per gram? Potato
//A paste made from which of these trees is traditionally used as a beauty product? Sandalwood
//Which of these do not come inside a pod? Potatoes
//Which of these microorganisms are infectious agents that can live and multiply only inside living cells of animals, plants, or bacteria? viruses, Protozoa, Fungi, Algae
//Chlorophyll - Which of these causes plants to be green?
//Tree leaves are green because of chlorophyll, a pigment vital for photosynthesis, the process where plants use sunlight to make food (sugars) and oxygen, absorbing red and blue light but reflecting green light, which is why they appear green to us. Chlorophyll is abundant during the growing season, indicating health, but breaks down in autumn, revealing other yellow/orange pigments (carotenoids) and allowing red/purple pigments (anthocyanins) to form, creating fall colors.
//The leaf - Which of these parts of the plant is called a 'food factory'?
//Which of these words refers to a preparation of food?
//Index - Which of these is normally found towards the end of a book?
//Kalahari and Gobi are examples of what kind of geographical feature? deserts
//Which of these terms best describes the hibiscus plant? shrub
//Grow below the ground
//https://drive.google.com/file/d/1f2Xi1K-XyB3BZH_hx7A7f-P4UFj87zR7/view